export default "/images/icon_key_available.svg?1e5203ac2dad0fc61f54eff0c276dce4";